import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAdminAuth } from "../../context/AdminAuthContext";
import { apiError } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Card } from "../../components/ui/card";
import { Leaf } from "lucide-react";

export default function AdminLogin() {
  const { login, admin } = useAdminAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (admin) navigate("/admin"); }, [admin, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await login(email, password); toast.success("Accesso effettuato"); navigate("/admin"); }
    catch (err) { toast.error(apiError(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center px-6">
      <Card className="p-8 rounded-3xl border-slate-700 bg-slate-800 w-full max-w-md">
        <div className="text-center mb-6">
          <Leaf className="w-10 h-10 text-emerald-400 mx-auto" />
          <h1 className="mt-4 text-2xl font-extrabold font-display text-white">Area Amministratore</h1>
          <p className="mt-1 text-slate-400 text-sm">Accedi per gestire il negozio</p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div><Label className="mb-1.5 block text-slate-300">Email</Label><Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="bg-slate-900 border-slate-700 text-white" data-testid="admin-email" /></div>
          <div><Label className="mb-1.5 block text-slate-300">Password</Label><Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="bg-slate-900 border-slate-700 text-white" data-testid="admin-password" /></div>
          <Button type="submit" disabled={loading} className="w-full rounded-full py-6" data-testid="admin-login-submit">{loading ? "Accesso..." : "Accedi"}</Button>
        </form>
      </Card>
    </div>
  );
}
